module.exports = __webpack_public_path__ + "media/application/images/features/inventory-syncing-800-ed1cc9680fc156d934caee5719c523cf.png";